 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		72: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		72: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"17":"BusinessProtect360.Generate","18":"CILeadForm","19":"CIP.FactFormApp","20":"CIProtect360.Dashboard","21":"CIProtect360.Details","22":"CIProtect360.Direct.Generate","23":"CIProtect360.Generate","24":"CampaignLeadForm","25":"CarProtect360","26":"CashCardShield","27":"CommissionStatement","28":"Common.Error","29":"ComplimentaryHomeContents","30":"ConsumerPortal","31":"ContactUs","32":"CorporateTravel","33":"Debug","34":"EMAPortal","35":"EarlyProtect360","36":"EarlyProtect360.Dashboard","37":"EarlyProtect360.Details","38":"FamilyProtect360","39":"FilipinoBond","40":"FlashPayShieldWithUpgrade","41":"HIProtect360Protect360","42":"HomeProtect360","43":"HomeProtectLite","44":"HomeSafe","45":"HomeStarterKit","46":"InternalDemoCookie","47":"KeymanProtect360","48":"KeymanProtect360.Dashboard","49":"KeymanProtect360.Details","50":"LeadForm","51":"LifePayment","52":"Loan Protect 360 Renewal","53":"MaidProtect360","54":"MotoringCardShieldWithUpgrade","55":"Motorshow2020","56":"PhoneProtect360","57":"PowerAgentPortal","58":"Prestige","59":"Prestige.Secured","60":"PublicHousingAssured","61":"ReviewUs","62":"SOA","63":"SingaporeTravelPass","64":"Touristcard","65":"TravelAssured","66":"TravelProtect360","67":"TravelProtect360Plus","68":"cileadform","69":"currencyconverter","71":"motorshow","73":"transferprotect360pro","74":"vCashCard","75":"weather"}[chunkId]||chunkId) + "." + {"0":"eeaac68b","1":"45f164c0","2":"2e97c3ca","3":"3e015a0e","4":"73f9aee4","5":"42c09efa","6":"cfb09ece","7":"c6555fdb","8":"5e953e0b","9":"6f5d6c04","10":"780438fb","11":"eb01ddd5","12":"87c8485b","13":"be7a8ec6","14":"4955d0e8","15":"39203841","16":"be705dbe","17":"3d6f7650","18":"96299dba","19":"86aa4c32","20":"bcf7eaba","21":"659746bc","22":"34dd73ec","23":"09edadfb","24":"f8295b39","25":"4c30fe4c","26":"318bf060","27":"6912dff0","28":"e2293146","29":"88158831","30":"dd390fde","31":"182a82e4","32":"8e2f8bc8","33":"55593d6f","34":"ccca2218","35":"41b12d48","36":"a552eabc","37":"8a043a9f","38":"83b28bd1","39":"d652e576","40":"53f8d74e","41":"320c223a","42":"5cb1c1ee","43":"9a447b15","44":"d3c2aa32","45":"5ef3d14f","46":"0feff370","47":"73d3bd95","48":"35e3b9be","49":"f668a777","50":"a60836a9","51":"b4778f62","52":"4909752e","53":"1b09a001","54":"6d5c3db8","55":"ffe83d6d","56":"c58b3a09","57":"9aeb1ebf","58":"c82733cc","59":"31efeb89","60":"c230be4f","61":"8ce20270","62":"7374a951","63":"b2719b18","64":"9853b745","65":"89817926","66":"6a27a927","67":"3ba1f692","68":"60c6f888","69":"b3ca8365","71":"c13b7c8d","73":"91effdbb","74":"94673b83","75":"76f2a204","77":"a4f94848","78":"40aa0489","79":"13e2ba2d","80":"69ed7ae9","81":"164bf81a","82":"ca061544","83":"90b098f6","84":"a80af9b3","85":"0969b794","86":"0ec0452b","87":"f089ac59","88":"d649a162","89":"688219b0","90":"ab45aa0f","91":"2d71c72e","92":"2bd13dc8","93":"0494c1ac","94":"3b6571fe","95":"891323c5","96":"83a5406e","97":"9d44d31c","98":"bf21530d","99":"17386af6","100":"72f80336","101":"6bed617d","102":"62c8783d","103":"fc7c1bbd","104":"09cde6f2","105":"e3300c7f","106":"a2154f40","107":"24efd83d","108":"67750651","109":"527ecfbf","110":"9f4c4a61","111":"6a8498cd","112":"5edda855","113":"d3725154","114":"97bda820","115":"6f304354","116":"077b91fd","117":"506b7eed","118":"0eb970e6","119":"9b0e54d8","120":"6a564266","121":"323b77e6","122":"ab86cfa8","123":"8c0b7733","124":"95b56952","125":"18e01e15","126":"0ba57bc7","127":"24063796","128":"eb2a11f4","129":"5dfbb96d","130":"d9d8f498","131":"5cb5a8c1","132":"50b982e7","133":"d62cfb10","134":"0617146e","135":"fa806112","136":"2d3c7999","137":"a1da892c","138":"838345bb","139":"51117977","140":"6909bff9","141":"0da50015","142":"ee5d443b","143":"1854d60f","144":"8a28f490","145":"b5cfe7e3"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"17":1,"19":1,"22":1,"24":1,"25":1,"26":1,"27":1,"29":1,"30":1,"32":1,"33":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"47":1,"50":1,"51":1,"53":1,"54":1,"56":1,"57":1,"58":1,"59":1,"60":1,"62":1,"63":1,"64":1,"65":1,"66":1,"67":1,"68":1,"69":1,"71":1,"73":1,"74":1,"75":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"90":1,"92":1,"97":1,"99":1,"103":1,"105":1,"106":1,"107":1,"108":1,"109":1,"110":1,"111":1,"124":1,"125":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"17":"BusinessProtect360.Generate","18":"CILeadForm","19":"CIP.FactFormApp","20":"CIProtect360.Dashboard","21":"CIProtect360.Details","22":"CIProtect360.Direct.Generate","23":"CIProtect360.Generate","24":"CampaignLeadForm","25":"CarProtect360","26":"CashCardShield","27":"CommissionStatement","28":"Common.Error","29":"ComplimentaryHomeContents","30":"ConsumerPortal","31":"ContactUs","32":"CorporateTravel","33":"Debug","34":"EMAPortal","35":"EarlyProtect360","36":"EarlyProtect360.Dashboard","37":"EarlyProtect360.Details","38":"FamilyProtect360","39":"FilipinoBond","40":"FlashPayShieldWithUpgrade","41":"HIProtect360Protect360","42":"HomeProtect360","43":"HomeProtectLite","44":"HomeSafe","45":"HomeStarterKit","46":"InternalDemoCookie","47":"KeymanProtect360","48":"KeymanProtect360.Dashboard","49":"KeymanProtect360.Details","50":"LeadForm","51":"LifePayment","52":"Loan Protect 360 Renewal","53":"MaidProtect360","54":"MotoringCardShieldWithUpgrade","55":"Motorshow2020","56":"PhoneProtect360","57":"PowerAgentPortal","58":"Prestige","59":"Prestige.Secured","60":"PublicHousingAssured","61":"ReviewUs","62":"SOA","63":"SingaporeTravelPass","64":"Touristcard","65":"TravelAssured","66":"TravelProtect360","67":"TravelProtect360Plus","68":"cileadform","69":"currencyconverter","71":"motorshow","73":"transferprotect360pro","74":"vCashCard","75":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"2ac86e1f","18":"31d6cfe0","19":"aa3b54e1","20":"31d6cfe0","21":"31d6cfe0","22":"58058363","23":"31d6cfe0","24":"7d5509f1","25":"8b4dd16d","26":"70e3c4a4","27":"aa3b54e1","28":"31d6cfe0","29":"1779625a","30":"a0a7763d","31":"31d6cfe0","32":"b5261879","33":"4a2f9c60","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"8b4dd16d","39":"8b4dd16d","40":"1779625a","41":"8b4dd16d","42":"3075a425","43":"3075a425","44":"3075a425","45":"1779625a","46":"31d6cfe0","47":"58058363","48":"31d6cfe0","49":"31d6cfe0","50":"03dd1e0e","51":"0a8270f7","52":"31d6cfe0","53":"2ceb63cb","54":"1779625a","55":"31d6cfe0","56":"3075a425","57":"872acbf8","58":"2fc531d7","59":"d12ec057","60":"3075a425","61":"31d6cfe0","62":"aa3b54e1","63":"ae092b8a","64":"168f912f","65":"85e49e50","66":"ae092b8a","67":"85e49e50","68":"d4af0650","69":"7b4f34de","71":"3b8df52f","73":"2ceb63cb","74":"33db1852","75":"c30f1711","77":"31d6cfe0","78":"cce35a68","79":"4efd6b30","80":"5fe76a74","81":"09c30e4b","82":"bca5ce90","83":"bca5ce90","84":"31d6cfe0","85":"31d6cfe0","86":"31d6cfe0","87":"31d6cfe0","88":"31d6cfe0","89":"31d6cfe0","90":"37fd3ee9","91":"31d6cfe0","92":"37fd3ee9","93":"31d6cfe0","94":"31d6cfe0","95":"31d6cfe0","96":"31d6cfe0","97":"37fd3ee9","98":"31d6cfe0","99":"37fd3ee9","100":"31d6cfe0","101":"31d6cfe0","102":"31d6cfe0","103":"4b48318c","104":"31d6cfe0","105":"4b48318c","106":"4b48318c","107":"4b48318c","108":"4b48318c","109":"4b48318c","110":"4b48318c","111":"4b48318c","112":"31d6cfe0","113":"31d6cfe0","114":"31d6cfe0","115":"31d6cfe0","116":"31d6cfe0","117":"31d6cfe0","118":"31d6cfe0","119":"31d6cfe0","120":"31d6cfe0","121":"31d6cfe0","122":"31d6cfe0","123":"31d6cfe0","124":"5fe6802c","125":"5fe6802c","126":"31d6cfe0","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"31d6cfe0","132":"31d6cfe0","133":"31d6cfe0","134":"31d6cfe0","135":"31d6cfe0","136":"31d6cfe0","137":"31d6cfe0","138":"31d6cfe0","139":"31d6cfe0","140":"31d6cfe0","141":"31d6cfe0","142":"31d6cfe0","143":"31d6cfe0","144":"31d6cfe0","145":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
